





































































































































































































import { defineComponent, reactive, watch, toRefs, computed } from '@vue/composition-api';

import SelectSessionItem from '@/components/SelectSessionItem.vue';
import DisplaySessionItems from '@/components/DisplaySessionItems.vue';
import { objectDiff } from '@/helpers/functions';
import { useStore } from '@/utils/use-store';
import { Exercise, Session } from '@/helpers/types';
import Draggable from 'vuedraggable';
import DisplaySessionExerciseItem from "@/components/DisplaySessionExersizeItem.vue";

interface State {
  [key: string]: any;
}

export default defineComponent({
  name: 'SessionForm',

  components: {
    DisplaySessionExerciseItem,
    SelectSessionItem,
    DisplaySessionItems,
    Draggable,
  },

  props: {
    session: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: () => 'create',
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    homeworkList: {
      type: Array,
      default: () => [],
    },
    warmUpList: {
      type: Array,
      default: () => [],
    },
    sessionExerciseList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
    exerciseOrderLoading: {
      type: Boolean,
      default: () => false,
    },
    setDefaultOrder: {
      type: Boolean,
      default: () => false,
    },
  },

  setup: function (props, { emit, refs }) {
    const requiredRule = [(v: any) => !!v || 'Field required!']
    const store = useStore();
    const { sessionTypes } = store.state;

    const state: State = reactive({
      tempSession: {
        name: '',
        description: '',
        day: '',
        date: new Date().toISOString(),
        type: 0,
      },
      showWarmUp: false,
      showExercise: false,
      showHomework: false,
      selectedWarmup: [] as any[],
      selectedExercise: [] as any[],
      selectedHomework: [] as any[],
    });

    const wodDate = computed({
      get: () => new Date(state.tempSession.date).toISOString().substr(0, 10),
      set: (value) => {
        state.tempSession.date = new Date(value).toISOString();
      }
    });

    watch(() => state.selectedWarmup, (selectedWarmup, prevValue) => {
      if (selectedWarmup.length > 1) {
        state.selectedWarmup.slice(0);
      }
    });

    watch(() => state.selectedHomework, (selectedHomework, prevValue) => {
      if (selectedHomework.length > 1) {
        state.selectedHomework.slice(0);
      }
    });

    watch(() => props.session, (value) => {
      const form: any = refs['session-form'];
      const temp = JSON.stringify(value);
      state.tempSession = JSON.parse(temp);
      if (value?.warmup?.length) {
        state.selectedWarmup = props.warmUpList.filter((wp: any) => value.warmup.map((swp: any) => swp.id).includes(wp.id));
      }
      if (value?.practices?.length) {
        state.selectedExercise = value.practices;
        if(state.selectedExercise.every((ex: Exercise) => !ex.order)) {
          state.selectedExercise = state.selectedExercise.map((exercise: Exercise, index: number) => ({ ...exercise, order: index }));
        }
      }
      if (value?.homework?.length) {
        state.selectedHomework = props.homeworkList.filter((exs: any) => value.homework.map((swp: any) => swp.id).includes(exs.id));
      }
      if (form) form.resetValidation();
    }, { deep: true, immediate: true });

    watch(() => props.setDefaultOrder, (value) => {
      if (value) {
        state.selectedExercise = state.selectedExercise.sort((a: Exercise, b: Exercise) => a.order - b.order);
        emit('defaultOrder')
      }
    });

    watch(() => props.isOpen, (value) => {
      if (!value) {
        state.selectedExercise = [];
        state.selectedHomework = [];
        state.selectedWarmup = [];
        state.showExercise = false;
        state.showExercise = false;
        state.showHomework = false;
      }
    });

    /**
     * Handler for close event
     * */
    function closeEventHandler() {
      emit('close');
    }

    function updateExercisesOrder() {
      const newArray = state.selectedExercise.map((exercise: Exercise, index: number) => ({ id: exercise.id, order: index }));
      emit('updateExercisesOrder', { records: newArray });
    }

    /**
     * Handler for select item event
     * @param {number} id
     * @param {string} type
     * */
    function selectEventHandler(id: number, type: any) {
      switch (type) {
        case 'warmup':
          state.selectedWarmup = state.selectedWarmup.find((warmup: any) => warmup.id === id)
            ? state.selectedWarmup.filter((warmup: any) => warmup.id !== id) as any
            : [...state.selectedWarmup, props.warmUpList.find((warmup: any) => warmup.id === id) as any[]];
          break;
        case 'exercise':
          state.selectedExercise = state.selectedExercise.find((exercise: any) => exercise.id === id)
            ? state.selectedExercise.filter((exercise: any) => exercise.id !== id) as any
            : [...state.selectedExercise, props.sessionExerciseList.find((exercise: any) => exercise.id === id) as any[]];
          break;
        case 'homework':
          state.selectedHomework = state.selectedHomework.find((warmup: any) => warmup.id === id)
            ? state.selectedHomework.filter((warmup: any) => warmup.id !== id) as any
            : props.homeworkList.filter((warmup: any) => warmup.id === id) as any[];
          break;
      }
    }

    /**
     * Handler for form submit event
     * */
    function submitEventHandler() {
      const form: any = refs['session-form'];
      let payload: Session = {
        name: '',
        day: '',
        date: new Date().toISOString(),
      };
      if (form.validate()) {
        if (props.mode === 'create') {
          payload = Object.assign({}, state.tempSession, {
            warmup: state.selectedWarmup.map((ex: Exercise) => ex.id)[0] || null,
            homeworks: state.selectedHomework.map((ex: Exercise) => ex.id)[0] || null,
            exercise: state.selectedExercise.map((ex: Exercise) => ex.id),
          });
          payload.date = new Date(payload.date || new Date().toISOString()).toISOString();
        } else {
          payload = objectDiff(props.session, Object.assign({}, {
            name: state.tempSession.name,
            description: state.tempSession.description,
            duration: state.tempSession.duration,
            day: state.tempSession.day,
            date: state.tempSession.date,
            type: state.tempSession.type,
            warmup: state.selectedWarmup.map((ex: Exercise) => ex.id)[0] || null,
            homeworks: state.selectedHomework.map((ex: Exercise) => ex.id)[0] || null,
            exercise: state.selectedExercise.map((ex: Exercise) => ex.id),
          }));
        }
        if (state.tempSession.type === 0) {
          delete payload.day;
        } else {
          delete payload.date;
        }
        emit(`${props.mode}-session`, payload);
      }
    }

    /**
     * Handler for archive event
     * */
    function archive() {
      confirm('Are you sure you want to archive this session?') && archiveEventHandler();
    }

    /**
     * Archive session
     * */
    function archiveEventHandler() {
      emit(`${props.mode}-session`, { active: false });
    }

    /**
     * Handler for remove item event
     * @param {object} payload
     * @param {number} payload.id
     * @param {string} payload.type
     * */
    function removeItemEventHandler({id, type}: {id: any, type: string}) {
      const optionName: string = `selected${type.charAt(0).toUpperCase() + type.slice(1)}`;
      state[optionName] = state[optionName].filter((ex: Exercise) => ex.id !== id);
    }

    return {
      requiredRule,
      sessionTypes,
      wodDate,
      ...toRefs(state),
      closeEventHandler,
      selectEventHandler,
      submitEventHandler,
      archive,
      removeItemEventHandler,
      updateExercisesOrder
    }
  }
});
